// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"651":"9078e83f25d7ee7c","741":"cd9485d61f910928"}[chunkId] + ".js";
};